<div class="wrap">
  <div class="padding-md">
    <div *ngIf="isOpenedFromModal" class="close-btn">
      <app-svg-icon (click)="onCloseClick()" name="close"></app-svg-icon>
    </div>
    <div class="week-container">
      <app-svg-icon class="icon" name="lightning"></app-svg-icon>
      <div class="week-name">
        {{ "@pages.inStoreProducts.thisWeek" | translate }}
      </div>
    </div>
    <div class="header">{{ "@pages.inStoreProducts.header" | translate }}</div>
  </div>
  <app-product-list
    [products]="products"
    (productClicked)="openProductDetails($event)"
    [scrollTrigger]="scrollTrigger$"
    [hideBuyButton]="true"
  ></app-product-list>
  <div class="padding-md">
    <app-action-button
      *ngIf="isOpenedFromModal"
      [isOutlined]="true"
      [label]="'@pages.inStoreProducts.actionBtn' | translate"
      (click)="onSeeAllProductsClick()"
    ></app-action-button>
  </div>
</div>
